module.exports = __webpack_public_path__ + "static/turtle-cfc0b545b746b3bce73cc1716e7a97cd.svg";